import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';

import Style from './ManageFavorites.module.scss';

const ManageFavorites = ({ headerProps, favorites = {} }) => (
  <main className={Style.manageFavorites}>
    <Header {...headerProps} />
    <div className={Style.manageFavoritesContainer}>
      <div className={Style.wrap}>{favorites}</div>
    </div>
  </main>
);

ManageFavorites.propTypes = {
  headerProps: PropTypes.shape({
    headerText: PropTypes.string,
    iconMobile: PropTypes.shape({}),
    isDesktop: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    showHeaderDesktop: PropTypes.bool,
    renderLogo: PropTypes.func.isRequired,
  }).isRequired,
  favorites: PropTypes.shape({}).isRequired,
};

export default ManageFavorites;
